import Axios from 'axios';
import ApiUtils from './api-utils';

export default {
  getAllParametres: () => ApiUtils.responseParser(Axios.get('/web/v1/parametres/DEFAULT')),
  modifierParametre: (param) => ApiUtils.responseParser(Axios.put(`/web/v1/parametres/DEFAULT/${param.categorie}/${param.code}`, param)),

  getAllParamAppli: () => ApiUtils.responseParser(Axios.get('/web/v1/parametres/CDEA')),
  modifParamAppli: (param) => ApiUtils.responseParser(Axios.put(`/web/v1/parametres/CDEA/${param.categorie}/${param.code}`, param))

};
